import InputLabelStyled from "@/components/InputLabelStyled";
import TextFieldStyled from "@/components/TextFieldStyled";
import { FormControl, FormHelperText, Radio, RadioGroup } from "@mui/material";
import Box from "@mui/material/Box";
import FormControlLabel from "@mui/material/FormControlLabel";
import Typography from "@mui/material/Typography";
import { useState } from "react";

const NetworkLocationFormBands = ({ onChange }) => {
  const [selectedValue, setSelectedValue] = useState("");
  const isRadioSelected = selectedValue !== "";

  const handleInputChanged = (event, value) => {
    if (onChange && typeof onChange === "function") {
      onChange(event, value);
    }
  };

  const handleRadioChange = (event) => {
    setSelectedValue(event.target.value);

    if (onChange && typeof onChange === "function") {
      onChange(event);
    }
  };

  return (
    <>
      <Typography
        variant="h4"
        component="p"
        color="common.black"
        sx={{ mt: 4 }}
      >
        Musiker*innen-spezifische Angaben
      </Typography>
      <Box sx={{ mt: 2, mb: -1 }}>
        <InputLabelStyled label="Typ" required={true} />
      </Box>
      <FormControl error={!isRadioSelected}>
        <RadioGroup
          row
          aria-labelledby="row-radio-buttons-group-label"
          name="type"
          value={selectedValue}
          onChange={handleRadioChange}
        >
          <FormControlLabel value="band" control={<Radio />} label="Band" />
          <FormControlLabel
            value="solo"
            control={<Radio />}
            label="Solo Musiker*in"
          />
        </RadioGroup>
        <FormHelperText>
          {!isRadioSelected && "Bitte wähle eine Option."}
        </FormHelperText>
      </FormControl>
      <TextFieldStyled
        name="genre"
        label="Genre"
        placeholder="z.B. Pop, Rock, Hip-Hop"
        onChange={handleInputChanged}
      />
    </>
  );
};

export default NetworkLocationFormBands;
